import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`If you are interested in cooperation, please send me a `}<a href="mailto:adrian.zawadzki@outlook.com">{`message`}</a>{` `}</p>
    <p>{`or find me on other platforms: `}<a href="https://github.com/Had3r">{`Github`}</a>{` & `}<a href="https://www.linkedin.com/in/adrian-zawadzki-181b8112a/">{`Linkedin`}</a>{`. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      